export default __webpack_public_path__ + "static/media/MH.bc2ccaa6.svg";